import React from "react";
import {
  IonBackButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonContent,
  IonHeader,
  IonPage, IonTitle,
  IonToolbar
} from '@ionic/react';
import { useLocation } from 'react-router-dom';
import parse from 'html-react-parser';
import Header from './Header';
import './ExploreContainer.css';

interface LocationState {
  title?: string;
  content?: string;
}

interface ContainerProps {
  name?: string;
  content?: string;
}

const ExploreContainer: React.FC<ContainerProps> = ({ name, content: propContent }) => {
  const location = useLocation<LocationState>();
  const title = location.state?.title || name || '';
  const htmlContent = location.state?.content || propContent || '';

  return (
    <IonPage>
      <IonHeader translucent>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref="/" />
          </IonButtons>
          <IonTitle size="large">{title}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen className="ion-padding">
        {htmlContent ? (
          <div className="explore-content">
            {parse(htmlContent)}
          </div>
        ) : (
          <IonCard>
            <IonCardContent>
              {title && <strong>{title}</strong>}
            </IonCardContent>
          </IonCard>
        )}
      </IonContent>
    </IonPage>
  );
};

export default ExploreContainer;
